import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

const IconArrowBottom = props => (
  <SvgIcon {...props} viewBox="0 0 16 16">
    <path d="m7 0v12.2l-5.6-5.6-1.4 1.4 8 8 8-8-1.4-1.4-5.6 5.6v-12.2h-2z" />
  </SvgIcon>
);

export default IconArrowBottom;



// WEBPACK FOOTER //
// ./src/components/icons/IconArrowBottom.js